import { platform } from "@/utils/platform";
import AKJS from "@akc/akjs";
import { useLayoutEffect, useState } from "react";

export const useAppStatusBarHeight = () => {
  const [statusBarHeight, setStatusBarHeight] = useState(50);

  // 计算状态栏高度，app按实际计算，其他端默认50
  const getStatusBar = () => {
    if (platform.isApp) {
      AKJS.ready().then(() => {
        AKJS.info.device().then((res: any) => {
          setStatusBarHeight(res?.data?.statusBarHeight || 50);
        });
      });
    }
  };

  useLayoutEffect(() => {
    getStatusBar();
  }, []);

  return statusBarHeight;
};
